import React, { useState, useRef } from "react";
import { f7, Page, Link, Icon, Row, Col, Button } from "framework7-react";
import axios from "axios";
import { API_BASE_URL, API_AUTH } from "./../globals";
// import logo from '../../src/img/logo/eatbids-sm-logo.png';

const OtpVerification = () => {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const inputRefs = useRef([]);

  const handleInputChange = (e, index) => {
    const newOtp = [...otp];
    newOtp[index] = e.target.value;
    setOtp(newOtp);

    if (e.target.value !== "" && index < 3) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleInputKeyPress = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleInputPaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text/plain");
    const otpArray = pastedText
      .slice(0, 4)
      .split("")
      .map((char) => (isNaN(char) ? "" : char));
    setOtp(otpArray);
  };

  const handleOTP = (e) => {
    e.preventDefault();
    const otpno = otp.join("");
    const custid = localStorage.getItem("id");
    const data = {
      otpno: otpno,
      custid: custid,
    };
    axios
      .post(API_BASE_URL + "custotp", data, {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.status === "success") {
          localStorage.setItem("auth", true);
          f7.views.main.router.navigate("/main/");
        } else {
          f7.dialog.alert("Incorrect otp ");
        }
      })
      .catch((error) => f7.dialog.alert("Error generating otp data!"));
  };
  const otpRegenerate = (e) => {
    e.preventDefault();
    const data = {
      custid: localStorage.getItem("id"),
    };
    axios
      .post(API_BASE_URL + "custotpsendagain", data, {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.status === "success") {
          f7.toast
            .create({
              text: "Otp sending ..",
              position: "top",
              cssClass: "bg-color-teal",
              closeTimeout: 3000,
            })
            .open();
          localStorage.setItem("auth", true);
        } else {
          f7.dialog.alert("Incorrect otp ");
        }
      })
      .catch((error) => f7.dialog.alert("Error generating otp data!"));
  };
  return (
    <Page className="bg-white">
      {/* <header className="section-t-space custom-web1">
        <div className="custom-container">
          <div className="header-panel">
            <Link href="#" back><Icon ios="material:keyboard_arrow_left" aurora="material:keyboard_arrow_left" md="material:keyboard_arrow_left" className='theme-dark' backLink="Back" ></Icon></Link>
            <h2>Verification</h2>
          </div>
        </div>
      </header> */}
      <div className="container container-table custom-web">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <div className="text-center">
            <header className="section-t-space">
              <div className="header-panel">
                <Link href="#" back>
                  <Icon
                    ios="material:keyboard_arrow_left"
                    aurora="material:keyboard_arrow_left"
                    md="material:keyboard_arrow_left"
                    className="theme-dark"
                    backLink="Back"
                  ></Icon>
                </Link>
                <h2>Verification</h2>
              </div>
            </header>
            <div className="otp-verification text-center">
              <h3 className="mb-3">We have sent a verification code to</h3>
              {/* <h3 className="otp-number mt-2 mb-3">abc***@**m</h3> */}
              <form onSubmit={handleOTP}>
                <Row>
                  {otp.map((digit, index) => (
                    <Col className="display-flex flex-direction-column">
                      <input
                        key={index}
                        type="tel"
                        maxLength={1}
                        value={digit}
                        placeholder=""
                        onChange={(e) => handleInputChange(e, index)}
                        onKeyPress={(e) => handleInputKeyPress(e, index)}
                        onPaste={(e) => handleInputPaste(e)}
                        ref={(ref) => (inputRefs.current[index] = ref)}
                        className="verify-input text-center"
                        // className={digit !== '' ? 'filled' : ''}
                      />
                    </Col>
                  ))}
                </Row>
                <p className="text-center mt-3 text-3">
                  Check spam folder for OTP
                </p>
                <p className="text-center mt-2 text-3">
                  Didn't recieve code?{" "}
                  <a type="button" onClick={otpRegenerate} className="yellow">
                    Request again
                  </a>
                </p>
                <Button
                  type="submit"
                  className="btn theme-btn w-100 mt-4"
                  large
                >
                  Verify Now
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="otp-container mt-5">
      <Block>
      <LoginScreenTitle className="mt-5"><img src={logo} alt="eatbids"/></LoginScreenTitle>
      <h4 className='text-center'>Verify Email</h4>
      <p className='text-center'>Code is sent to email</p>
      <form>
        <Row>
        {otp.map((digit, index) => (
          <Col className='display-flex flex-direction-column'>
          <input
            key={index}
            type="tel"
            maxLength={1}
            value={digit}
            placeholder=""
            onChange={(e) => handleInputChange(e, index)}
            onKeyPress={(e) => handleInputKeyPress(e, index)}
            onPaste={(e) => handleInputPaste(e)}
            ref={(ref) => inputRefs.current[index] = ref}
            className='verify-input text-center'
            // className={digit !== '' ? 'filled' : ''}
          />
          </Col>
        ))} 
        </Row>
        </form>
        <p className="text-center mt-5">Didn't recieve code? <a href="/register/">Request again</a></p>
        <Button fill large className="mt-3" onClick={handleOTP}>
          Verify Now
        </Button>
      </Block>
      </div> */}
    </Page>
  );
};

export default OtpVerification;
